import { useCallback, useState } from 'react';

export const usePageResetOnChange = (resetKey?: string): [number, (page: number) => void] => {
    const [state, setState] = useState({ resetKey, page: 1 });
    const page = state.resetKey === resetKey ? state.page : 1;
    const setPage = useCallback((newPage: number) => setState({ resetKey, page: newPage }), [resetKey]);
    return [page, setPage];
};
